import React from "react";
import CommonPopup from "../../../common-popup/CommonPopup";
import { formatPrice } from '../../../../helper/commonFunction';
import { calculateDifference } from '../utils/bookingHelpers';

/**
 * PreBookingPriceRevisionPopup
 *
 * Modal shown before confirming payment when the airline has revised the price
 * (currently used for Amadeus re-confirmation flow).
 * Displays original price, updated price, and the difference.
 * User can proceed to Pay Now (with loading state) or Cancel (resets the flow).
 *
 * Props:
 *   checkPriceBeforeBooking  – { showForm, amount: { actualAmount, originalAmount } }
 *   payNowBtnLoader          – boolean, shows spinner on Pay Now button when true
 *   step2PayNowBtnFn         – handler to proceed with payment (called with false, false)
 *   setCheckPriceBeforeBooking – state setter to reset/close the popup
 *   amadeusReconfirmRef      – React ref holding the pending Amadeus reconfirm state
 *                              (cleared on Cancel to force a fresh create-order on retry)
 */
const PreBookingPriceRevisionPopup = ({
    checkPriceBeforeBooking,
    payNowBtnLoader,
    step2PayNowBtnFn,
    setCheckPriceBeforeBooking,
    amadeusReconfirmRef,
}) => {
    if (!checkPriceBeforeBooking?.showForm) return null;

    return (
        <CommonPopup
            show={checkPriceBeforeBooking?.showForm}
            setShow={() => {
                setCheckPriceBeforeBooking({})
                amadeusReconfirmRef.current = {}
            }}
            title={'Price Updated'}
        >
            <div>
                <div className="h6 text-center">Your selected flight price has been revised by the airline.</div>
                <div className="hw-table--responsive mt-3">
                    <table className="hw-table--border lr-borderNull xl-big hw-table--baggage">
                        <thead>
                            <tr>
                                <th>Original Price</th>
                                <th>Updated Price</th>
                                <th>Price Difference</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formatPrice(checkPriceBeforeBooking?.amount?.actualAmount, true, true)}</td>
                                <td>{formatPrice(checkPriceBeforeBooking?.amount?.originalAmount, true, true)}</td>
                                <td>{formatPrice(calculateDifference(parseFloat(checkPriceBeforeBooking?.amount?.actualAmount), parseFloat(checkPriceBeforeBooking?.amount?.originalAmount)), true, true)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="d-flex mt-4 hw-gapy16">
                    <button onClick={() => {
                        step2PayNowBtnFn(false, false)
                    }} className="hw-btn hw-btn--primary w-100" disabled={payNowBtnLoader}>{payNowBtnLoader ?
                        <span style={{ minWidth: '2.8rem', minHeight: "2.8rem" }}
                            className='hw-main--loaderCommon' /> : 'Pay Now'}</button>
                    <button className="hw-btn hw-btn--secondary w-100" onClick={() => {
                        setCheckPriceBeforeBooking({})
                        // Drop the created order: clicking Pay Now again starts a fresh
                        // create-order rather than issuing an abandoned one.
                        amadeusReconfirmRef.current = {}
                    }}>Cancel</button>
                </div>
            </div>
        </CommonPopup>
    );
};

export default PreBookingPriceRevisionPopup;
